module.exports = __webpack_public_path__ + "static/media/ccass_holding.268792a2.png";